var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Print as PrintIcon } from '@mui/icons-material';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { fetchResource } from '../../../api';
import LogoFunac from '../../../public/nova_chance_logo.png';
var GREEN = {
    dark: '#1b4332',
    primary: '#2d6a4f',
    light: '#d8f3dc',
    accent: '#40916c',
    rowAlt: '#f8faf9',
};
var PAGE = {
    fontFamily: "'Inter', 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: '11px',
    color: '#1f2937',
    maxWidth: 920,
    margin: '0 auto',
    padding: '28px 36px',
    lineHeight: 1.45,
};
var isValorNeutro = function (valor) {
    return valor === '—' || valor === '---' || valor === '--:--' || !valor;
};
var getDiaSemanaLabel = function (dataIso) {
    var _a;
    var _b = dataIso.split('-').map(Number), ano = _b[0], mes = _b[1], dia = _b[2];
    if (!ano || !mes || !dia)
        return '';
    var data = new Date(Date.UTC(ano, mes - 1, dia));
    var dias = ['DOMINGO', 'SEGUNDA', 'TERÇA', 'QUARTA', 'QUINTA', 'SEXTA', 'SÁBADO'];
    return (_a = dias[data.getUTCDay()]) !== null && _a !== void 0 ? _a : '';
};
var getStatusExibicao = function (linha) {
    var _a, _b, _c, _d;
    if (linha.dia_tipo === 'FIM_DE_SEMANA') {
        var dia = getDiaSemanaLabel(linha.data);
        if (dia === 'DOMINGO' || dia === 'SÁBADO') {
            return { label: dia, tipo: 'fds' };
        }
        return { label: 'FIM DE SEMANA', tipo: 'fds' };
    }
    var codigo = ((_b = (_a = linha.status_dia) === null || _a === void 0 ? void 0 : _a.codigo) !== null && _b !== void 0 ? _b : '').toUpperCase();
    if (codigo.includes('REPROV')) {
        return { label: (_c = linha.status_dia.label) !== null && _c !== void 0 ? _c : 'REPROVADO', tipo: 'erro' };
    }
    if (codigo.includes('APROV') || codigo.includes('REGULAR') || !codigo) {
        return { label: 'REGULAR', tipo: 'ok' };
    }
    return { label: (_d = linha.status_dia.label) !== null && _d !== void 0 ? _d : 'REGULAR', tipo: 'ok' };
};
var CampoInfo = function (_a) {
    var label = _a.label, valor = _a.valor, _b = _a.flex, flex = _b === void 0 ? 1 : _b;
    return (_jsxs(Box, __assign({ sx: {
            flex: flex,
            border: '1px solid #d1d5db',
            borderRadius: '2px',
            px: 1.25,
            py: 0.75,
            minHeight: 52,
            backgroundColor: '#fff',
        } }, { children: [_jsx(Typography, __assign({ sx: {
                    fontSize: '8px',
                    fontWeight: 700,
                    color: '#6b7280',
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em',
                    mb: 0.35,
                } }, { children: label })), _jsx(Typography, __assign({ sx: {
                    fontSize: '11px',
                    fontWeight: 700,
                    color: '#111827',
                    textTransform: 'uppercase',
                    lineHeight: 1.25,
                } }, { children: valor || '—' }))] })));
};
var CaixaAssinatura = function (_a) {
    var bloco = _a.bloco;
    return (_jsxs(Box, __assign({ sx: {
            flex: 1,
            border: '1px solid #d1d5db',
            borderRadius: '2px',
            p: 1.5,
            minHeight: 130,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
        } }, { children: [_jsx(Typography, __assign({ sx: {
                    fontSize: '8px',
                    fontWeight: 700,
                    color: '#6b7280',
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em',
                    mb: 1,
                } }, { children: bloco.rotulo })), _jsx(Typography, __assign({ sx: {
                    fontSize: '10px',
                    fontWeight: 800,
                    color: bloco.assinado ? GREEN.primary : '#9ca3af',
                    textTransform: 'uppercase',
                    mb: 1,
                } }, { children: bloco.status_texto })), _jsx(Typography, __assign({ sx: { fontSize: '10px', fontWeight: 700, color: '#111827', textTransform: 'uppercase' } }, { children: bloco.nome || '—' })), bloco.cargo && (_jsxs(Typography, __assign({ sx: { fontSize: '9px', color: '#6b7280', mt: 0.5 } }, { children: ["Cargo: ", bloco.cargo] }))), bloco.data_hora_exibicao && (_jsx(Typography, __assign({ sx: { fontSize: '9px', color: '#9ca3af', mt: 'auto', pt: 1 } }, { children: bloco.data_hora_exibicao })))] })));
};
export default function RelatorioFrequenciaMensal() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var searchParams = useSearchParams()[0];
    var folhaId = searchParams.get('folhaId');
    var dataInicio = searchParams.get('data_inicio');
    var dataFim = searchParams.get('data_fim');
    var _j = useState(true), loading = _j[0], setLoading = _j[1];
    var _k = useState(null), dados = _k[0], setDados = _k[1];
    var _l = useState(false), erro = _l[0], setErro = _l[1];
    var _m = useState(false), logoErro = _m[0], setLogoErro = _m[1];
    var _o = useState(null), mensagemErro = _o[0], setMensagemErro = _o[1];
    useEffect(function () {
        if (folhaId)
            carregarRelatorio(Number(folhaId), dataInicio, dataFim);
        else
            setErro(true);
    }, [folhaId, dataInicio, dataFim]);
    var carregarRelatorio = function (id, inicio, fim) { return __awaiter(_this, void 0, void 0, function () {
        var params, qs, url, resp, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    setMensagemErro(null);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    params = new URLSearchParams();
                    if (inicio && fim) {
                        params.append('data_inicio', inicio);
                        params.append('data_fim', fim);
                    }
                    qs = params.toString();
                    url = "reeducandos-pontos/fechamento-mensal/".concat(id, "/relatorio-detalhado").concat(qs ? '?' + qs : '');
                    return [4 /*yield*/, fetchResource(url)];
                case 2:
                    resp = _c.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK' && resp.dados) {
                        setDados(resp.dados);
                    }
                    else {
                        setMensagemErro((_b = resp === null || resp === void 0 ? void 0 : resp.Mensagem) !== null && _b !== void 0 ? _b : 'Não foi possível carregar o relatório.');
                        setErro(true);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _a = _c.sent();
                    setMensagemErro('Não foi possível carregar o relatório. Verifique a conexão e tente novamente.');
                    setErro(true);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        if ((_a = dados === null || dados === void 0 ? void 0 : dados.relatorio) === null || _a === void 0 ? void 0 : _a.barra_titulo)
            document.title = dados.relatorio.barra_titulo;
    }, [dados]);
    var handleImprimir = function () { return window.print(); };
    if (loading) {
        return (_jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f9fafb' } }, { children: _jsx(CircularProgress, { sx: { color: GREEN.primary } }) })));
    }
    if (erro || !dados) {
        return (_jsx(Box, __assign({ sx: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f9fafb', gap: 2, px: 3 } }, { children: _jsxs(Box, __assign({ sx: {
                    maxWidth: 480, width: '100%', textAlign: 'center',
                    backgroundColor: '#fff', borderRadius: 3, p: 4,
                    border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                } }, { children: [_jsx(Box, __assign({ sx: {
                            width: 56, height: 56, borderRadius: '50%',
                            backgroundColor: mensagemErro ? '#fef3c7' : '#fee2e2',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            margin: '0 auto', mb: 2,
                        } }, { children: _jsx(Typography, __assign({ sx: { fontSize: '24px' } }, { children: mensagemErro ? '⚠️' : '❌' })) })), _jsx(Typography, __assign({ variant: "h6", sx: { fontWeight: 700, color: '#111827', mb: 1 } }, { children: mensagemErro ? 'Relatório Indisponível' : 'Erro ao Carregar' })), _jsx(Typography, __assign({ variant: "body2", sx: { color: '#4b5563', lineHeight: 1.6 } }, { children: mensagemErro || 'Não foi possível carregar o relatório. Verifique a conexão e tente novamente.' }))] })) })));
    }
    var relatorio = dados.relatorio, identificacao = dados.identificacao, resumo_mensal = dados.resumo_mensal, assinaturas = dados.assinaturas, frequencia_diaria = dados.frequencia_diaria;
    var cols = frequencia_diaria.colunas.filter(function (c) { return c.visivel; });
    var showE2S2 = cols.some(function (c) { return c.codigo === 'E2'; }) && cols.some(function (c) { return c.codigo === 'S2'; });
    var resumo = resumo_mensal !== null && resumo_mensal !== void 0 ? resumo_mensal : {
        dias_trabalhados: 0,
        dias_trabalhados_exibicao: '00',
        horas_realizadas: '0h',
        faltas_justificadas: 0,
        faltas_justificadas_exibicao: '00',
        total_abonado: '0h',
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ className: "no-print", sx: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    px: 3,
                    py: 1.5,
                    backgroundColor: GREEN.dark,
                    color: 'white',
                    borderBottom: "1px solid ".concat(GREEN.primary),
                    '@media print': { display: 'none' },
                } }, { children: [_jsx(Typography, __assign({ sx: { fontWeight: 600, fontSize: '0.88rem' } }, { children: relatorio.barra_titulo })), _jsx(Button, __assign({ variant: "contained", startIcon: _jsx(PrintIcon, {}), onClick: handleImprimir, sx: {
                            fontWeight: 700,
                            textTransform: 'none',
                            backgroundColor: GREEN.accent,
                            '&:hover': { backgroundColor: GREEN.primary },
                        } }, { children: "IMPRIMIR / SALVAR PDF" }))] })), _jsxs(Box, __assign({ sx: __assign(__assign({}, PAGE), { backgroundColor: '#fff', minHeight: '100vh' }) }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1.5, pb: 1.5 } }, { children: [_jsx(Box, __assign({ sx: {
                                    height: 56,
                                    minWidth: 160,
                                    px: 1.5,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: GREEN.dark,
                                    borderRadius: '2px',
                                } }, { children: logoErro ? (_jsx(Typography, __assign({ sx: { color: '#fff', fontSize: '10px', fontWeight: 800, letterSpacing: '0.04em' } }, { children: "FUNDA\u00C7\u00C3O NOVA CHANCE" }))) : (_jsx(Box, { component: "img", src: LogoFunac, alt: "Funda\u00E7\u00E3o Nova Chance", sx: { height: 48, maxWidth: 150, objectFit: 'contain' }, onError: function () { return setLogoErro(true); } })) })), _jsxs(Box, { children: [_jsx(Typography, __assign({ sx: {
                                            fontSize: '22px',
                                            fontWeight: 900,
                                            color: GREEN.dark,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.02em',
                                            lineHeight: 1.1,
                                        } }, { children: relatorio.titulo })), _jsx(Typography, __assign({ sx: { fontSize: '10px', fontWeight: 700, color: '#111827', textTransform: 'uppercase', mt: 0.5 } }, { children: (_a = relatorio.subtitulo_instituicao) !== null && _a !== void 0 ? _a : 'SECRETARIA DE ESTADO DE JUSTIÇA' })), _jsx(Typography, __assign({ sx: { fontSize: '10px', fontWeight: 600, color: '#374151', textTransform: 'uppercase' } }, { children: relatorio.sistema }))] })] })), _jsx(Box, { sx: { height: 4, backgroundColor: GREEN.dark, mb: 2 } }), _jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'column', gap: 1, mb: 2 } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', gap: 1 } }, { children: [_jsx(CampoInfo, { label: "Nome do Colaborador / Cooperado", valor: identificacao.reeducando_nome_exibicao }), _jsx(CampoInfo, { label: "Matr\u00EDcula / ID", valor: identificacao.matricula_exibicao, flex: 0.55 })] })), _jsxs(Box, __assign({ sx: { display: 'flex', gap: 1 } }, { children: [_jsx(CampoInfo, { label: "CPF", valor: identificacao.cpf_exibicao }), _jsx(CampoInfo, { label: "Cargo", valor: identificacao.cargo_exibicao })] })), _jsxs(Box, __assign({ sx: { display: 'flex', gap: 1 } }, { children: [_jsx(CampoInfo, { label: "Contrato / Empresa", valor: (_b = identificacao.empresa_contratante_exibicao) !== null && _b !== void 0 ? _b : identificacao.empresa_contratante }), _jsx(CampoInfo, { label: "Per\u00EDodo", valor: (_d = (_c = identificacao.periodo_exibicao) !== null && _c !== void 0 ? _c : relatorio.periodo_exibicao) !== null && _d !== void 0 ? _d : relatorio.periodo })] })), _jsxs(Box, __assign({ sx: { display: 'flex', gap: 1 } }, { children: [_jsx(CampoInfo, { label: "Fiscal Respons\u00E1vel", valor: identificacao.fiscal_responsavel_exibicao }), _jsx(CampoInfo, { label: "Local de Trabalho", valor: identificacao.local_trabalho_exibicao })] }))] })), _jsxs("table", __assign({ style: { width: '100%', borderCollapse: 'collapse', fontSize: '10px', marginBottom: 16 } }, { children: [_jsx("thead", { children: _jsx("tr", __assign({ style: { backgroundColor: GREEN.dark, color: '#fff' } }, { children: __spreadArray(__spreadArray(['DATA', 'E1', 'S1'], (showE2S2 ? ['E2', 'S2'] : []), true), ['TOTAL', 'STATUS'], false).map(function (col) { return (_jsx("th", __assign({ style: thStyle }, { children: col }), col)); }) })) }), _jsx("tbody", { children: frequencia_diaria.linhas.map(function (linha, idx) {
                                    var _a;
                                    var isFds = linha.dia_tipo === 'FIM_DE_SEMANA';
                                    var status = getStatusExibicao(linha);
                                    var bg = idx % 2 === 1 ? GREEN.rowAlt : '#fff';
                                    return (_jsxs("tr", __assign({ style: { backgroundColor: bg, borderBottom: '1px solid #e5e7eb' } }, { children: [_jsx("td", __assign({ style: tdStyle }, { children: linha.data_exibicao })), _jsx("td", __assign({ style: tdStyle }, { children: isFds || isValorNeutro(linha.registros_ponto.E1) ? '--:--' : linha.registros_ponto.E1 })), _jsx("td", __assign({ style: tdStyle }, { children: isFds || isValorNeutro(linha.registros_ponto.S1) ? '--:--' : linha.registros_ponto.S1 })), showE2S2 && (_jsx("td", __assign({ style: tdStyle }, { children: isFds || isValorNeutro(linha.registros_ponto.E2) ? '--:--' : linha.registros_ponto.E2 }))), showE2S2 && (_jsx("td", __assign({ style: tdStyle }, { children: isFds || isValorNeutro(linha.registros_ponto.S2) ? '--:--' : linha.registros_ponto.S2 }))), _jsx("td", __assign({ style: __assign(__assign({}, tdStyle), { fontWeight: 700 }) }, { children: (_a = linha.total) !== null && _a !== void 0 ? _a : (isFds ? '0h' : '—') })), _jsx("td", __assign({ style: tdStyle }, { children: _jsx("span", __assign({ style: {
                                                        fontWeight: status.tipo === 'ok' ? 800 : 600,
                                                        color: status.tipo === 'ok'
                                                            ? GREEN.primary
                                                            : status.tipo === 'erro'
                                                                ? '#b91c1c'
                                                                : '#6b7280',
                                                        fontSize: '9px',
                                                        textTransform: 'uppercase',
                                                    } }, { children: status.label })) }))] }), linha.data));
                                }) })] })), _jsxs(Box, __assign({ sx: {
                            display: 'flex',
                            alignItems: 'stretch',
                            mb: 2.5,
                            border: "1px solid ".concat(GREEN.light),
                            backgroundColor: GREEN.light,
                            overflow: 'hidden',
                        } }, { children: [_jsx(Box, { sx: { width: 6, backgroundColor: GREEN.dark, flexShrink: 0 } }), _jsxs(Box, __assign({ sx: { flex: 1, p: 1.5 } }, { children: [_jsx(Typography, __assign({ sx: {
                                            fontSize: '11px',
                                            fontWeight: 800,
                                            color: GREEN.dark,
                                            textTransform: 'uppercase',
                                            mb: 1,
                                        } }, { children: "Resumo Mensal" })), _jsxs(Box, __assign({ sx: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            width: '100%',
                                            flexWrap: 'wrap',
                                            gap: 1,
                                        } }, { children: [_jsxs(Typography, __assign({ sx: { fontSize: '11px', color: '#111827', flex: 1, textAlign: 'center', minWidth: 120 } }, { children: [_jsx("strong", { children: "Dias Trabalhados:" }), " ", (_e = resumo.dias_trabalhados_exibicao) !== null && _e !== void 0 ? _e : resumo.dias_trabalhados] })), _jsxs(Typography, __assign({ sx: { fontSize: '11px', color: '#111827', flex: 1, textAlign: 'center', minWidth: 120 } }, { children: [_jsx("strong", { children: "Horas Realizadas:" }), " ", resumo.horas_realizadas] })), _jsxs(Typography, __assign({ sx: { fontSize: '11px', color: '#111827', flex: 1, textAlign: 'center', minWidth: 120 } }, { children: [_jsx("strong", { children: "Faltas Justificadas:" }), " ", (_f = resumo.faltas_justificadas_exibicao) !== null && _f !== void 0 ? _f : resumo.faltas_justificadas] })), _jsxs(Typography, __assign({ sx: { fontSize: '11px', color: '#111827', flex: 1, textAlign: 'center', minWidth: 120 } }, { children: [_jsx("strong", { children: "Total Abonado:" }), " ", resumo.total_abonado] }))] }))] }))] })), assinaturas && (_jsxs(Box, __assign({ sx: { display: 'flex', gap: 1.5, mb: 3 } }, { children: [_jsx(CaixaAssinatura, { bloco: assinaturas.cooperado }), _jsx(CaixaAssinatura, { bloco: assinaturas.fiscal_local }), _jsx(CaixaAssinatura, { bloco: assinaturas.analista_funac })] }))), _jsxs(Box, __assign({ sx: { textAlign: 'center', pt: 1 } }, { children: [_jsx(Typography, __assign({ sx: { fontSize: '9px', color: '#9ca3af', mb: 0.25 } }, { children: (_g = relatorio.rodape_linha_1) !== null && _g !== void 0 ? _g : relatorio.rodape_esquerda })), _jsx(Typography, __assign({ sx: { fontSize: '9px', color: '#9ca3af' } }, { children: (_h = relatorio.rodape_linha_2) !== null && _h !== void 0 ? _h : relatorio.rodape_direita }))] }))] })), _jsx("style", { children: "\n        @media print {\n          .no-print { display: none !important; }\n          body { margin: 0; padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }\n          @page { margin: 12mm 10mm; size: A4; }\n        }\n      " })] }));
}
var thStyle = {
    padding: '7px 8px',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '9px',
    letterSpacing: '0.04em',
    borderBottom: 'none',
};
var tdStyle = {
    padding: '5px 8px',
    fontSize: '10px',
    textAlign: 'center',
    verticalAlign: 'middle',
};
